<template>
	<v-col cols="12" md="6" class="pa-2"> 
		<div :style="styles" class="gridPhoto">
			<div class="badgeRight">{{corner}}</div>
			<p class="shadow text-h4 text-lg-h3 font-weight-bold white--text mt-7">
				{{title}}
			</p>
			<v-chip v-for="badge in badges" :color="badge.color" dark class="mr-4" :key="badge.content">{{badge.content}}</v-chip>
		</div>
	</v-col>
</template>
<style lang="less" scoped>
	.gridPhoto{
		padding: 25px 10px;
		position: relative;
		height: 100%;
	}
	.shadow{
		text-shadow: 1px 1px grey;
	}
	
	.badgeRight{
		padding: 12px;
		width: auto;
		display: inline-block;
		position: absolute;
		top: 0;
		right: 0;
		color: white;
		background-color: #86BD60;
		font-size: 1.8em;
		font-weight: bold;
	}
</style>
<script type="text/javascript">
	export default{
		name: "GridPhoto", 
		props: [
			"title",
			"background", 
			"badges",
			"corner"
		],
		computed: {
			styles(){
				var obj = {

				}
				obj["background-image"] = `url(${this.background})`;
				obj["background-size"] = "cover";
				obj["background-position"] = "center";
				return obj;
			}
		}
	}
</script>